var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.62492 10.9502H0.374989C0.167995 10.9502 0 10.7941 0 10.6018V5.02851C0 4.83623 0.167995 4.68018 0.374989 4.68018H2.62492C2.83191 4.68018 2.99991 4.83623 2.99991 5.02851V10.6018C2.99991 10.7941 2.83191 10.9502 2.62492 10.9502Z",
    fill: "#9F73E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75029 10.9496H3.75048C3.54348 10.9496 3.37549 10.7936 3.37549 10.6013V5.02796C3.37549 4.97849 3.38674 4.93007 3.40849 4.88479L4.92419 1.75641C5.13118 1.40181 5.48667 1.19629 5.86429 1.19629C6.05328 1.19629 6.23703 1.24819 6.39565 1.34642C6.81188 1.60384 7.12537 2.17754 7.12537 2.68123V4.33129C7.12537 4.52322 7.29337 4.67962 7.50036 4.67962H10.1253C10.7455 4.67962 11.2502 5.14848 11.2502 5.72462L10.8738 9.93353C10.8753 10.4808 10.3705 10.9496 9.75029 10.9496Z",
    fill: "#9F73E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_988_10443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.2533H4.50023C4.29324 10.2533 4.12524 10.0973 4.12524 9.905V4.33167C4.12524 4.2822 4.13649 4.23379 4.15824 4.1885L5.67395 1.06012C5.88094 0.705517 6.23643 0.5 6.61404 0.5C6.80304 0.5 6.98678 0.551902 7.1454 0.650132C7.56164 0.90755 7.87513 1.48126 7.87513 1.98495V3.635C7.87513 3.82693 8.04312 3.98333 8.25012 3.98333H10.875C11.4953 3.98333 12 4.45219 12 5.02833L11.6235 9.23725C11.625 9.78448 11.1203 10.2533 10.5 10.2533Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_988_10443",
    x: 2.22524,
    y: -1.4,
    width: 11.6748,
    height: 13.5534,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_988_10443"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_988_10443",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRate);
export default __webpack_public_path__ + "static/media/rate.c4b91981f359a9f40be204dd3332f4b9.svg";
export { ForwardRef as ReactComponent };